export enum ColorModes {
  success = 'SUCCESS',
  warning = 'WARNING',
  error = 'ERROR',
  blue = 'BLUE',
  gray = 'GRAY',
  yellow = 'YELLOW',
  pinkGraph = 'PINK_GRAPH',
  violet = 'VIOLET',
}
